const SETTINGS = [
    {
        label: 'تماس با ما',
        name: 'CONTACT',
        code: 101,
        color: '',
        schema: {
            fields: {
                text: {
                    type: 'text'
                }
            }
        },
    },
    {
        label: 'درباره',
        name: 'ABOUT',
        code: 100,
        color: '',
        schema: {
            fields: {
                text: {
                    type: 'text'
                }
            }
        },
    },
    {
        label: 'عنوان سایت',
        name: 'SITE_TITLE',
        code: 102,
        color: '',
        noTitle: true,
        schema: {
            fields: {
                text: {
                    type: 'text'
                }
            }
        },
    },
    {
        label: 'درباره سایت (meta)',
        name: 'SITE_DESC',
        code: 103,
        color: '',
        noTitle: true,
        schema: {
            fields: {
                text: {
                    type: 'text'
                }
            }
        },
    },
    {
        label: 'تنظیمات RSS',
        name: 'RSS_SETT',
        code: 104,
        color: '',
        noTitle: true,
        schema: {
            fields: [
                {
                    'name': 'title',
                    'label': 'تیتر',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'label': 'درباره',
                    'name': 'description',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'managingEditor',
                    'label': 'سردبیر',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                },
                {
                    'name': 'webMaster',
                    'label': 'وب مستر',
                    'type': 'text',
                    'validation': {},
                    'layout': {}
                }
            ]
        },
    },
]

SETTINGS.byName = (name) => SETTINGS.find(s => s.name === name)

export { SETTINGS }